import { Link } from "react-router-dom";
import {
  Mail,
  Phone,
  MailOpen,
  Facebook,
  Twitter,
  Linkedin,
  Instagram,
  MessageCircle,
 
  Send,
} from "lucide-react";

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="w-full bg-neutral-50 border-t border-neutral-200 mt-20 pt-16">
      <div className="container max-w-7xl mx-auto px-6">
        {/* Top Section: Brand & Newsletter */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 pb-12 border-b border-neutral-200">
          {/* Brand Info */}
          <div className="space-y-6">
            <div className="text-3xl font-extrabold text-[#163A8F]">الخير</div>
            <p className="text-neutral-600 text-sm leading-8 max-w-md">
              مؤسسة الخير تأسست عام 2003، تركز على المساعدات والتنمية، تعمل
              عالمياً، تلتزم بالشفافية والاستدامة، تشارك في التنمية بالشرق
              الأوسط.
            </p>

            <div className="flex flex-wrap gap-8">
              <div className="flex items-center gap-4 group">
                <div className="w-12 h-12 bg-white shadow-sm border border-neutral-200 rounded-full flex items-center justify-center transition-colors group-hover:bg-[#163A8F]">
                  <Mail className="w-5 h-5 text-[#163A8F] group-hover:text-white transition-colors" />
                </div>
                <div>
                  <div className="text-neutral-500 text-xs">راسلنا على</div>
                  <div className="text-neutral-900 text-sm font-semibold">
                    info@alkhair.org
                  </div>
                </div>
              </div>

              <div className="flex items-center gap-4 group">
                <div className="w-12 h-12 bg-white shadow-sm border border-neutral-200 rounded-full flex items-center justify-center transition-colors group-hover:bg-[#163A8F]">
                  <Phone className="w-5 h-5 text-[#163A8F] group-hover:text-white transition-colors" />
                </div>
                <div>
                  <div className="text-neutral-500 text-xs">
                    هل لديك إستفسار؟
                  </div>
                  <div
                    className="text-neutral-900 text-sm font-semibold"
                    dir="ltr"
                  >
                    +44 7360931094
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Newsletter Section */}
          <div className="bg-[#163A8F]/5 p-8 rounded-2xl flex flex-col justify-center">
            <h3 className="text-neutral-900 text-xl font-bold mb-2">
              النشرة الإخبارية
            </h3>
            <p className="text-neutral-600 text-sm mb-6">
              اشترك بالنشرة الإخبارية ليصل كل جديد منا ...
            </p>

            <form className="relative flex items-center">
              <div className="absolute right-4 text-neutral-400">
                <MailOpen size={18} />
              </div>
              <input
                type="email"
                placeholder="ادخل البريد الإلكتروني"
                className="w-full pr-12 pl-32 py-4 bg-white border border-neutral-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#163A8F]/20 transition-all text-sm"
              />
              <button className="absolute left-2 px-6 py-2.5 bg-amber-400 hover:bg-amber-500 text-neutral-900 font-bold rounded-lg transition-all text-sm shadow-sm flex items-center gap-2">
                إشتراك
                <Send size={14} />
              </button>
            </form>
          </div>
        </div>

        {/* Middle Section: Links */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-10 py-16">
          <FooterColumn
            title="عنّا"
            links={[
              { label: "إتصل بنا", to: "/call-us" },
              { label: "قصص النجاح", to: "/success-stories" },
              { label: "أسئلة شائعة", to: "/most-questioned" },
              { label: "أخر الأخبار", to: "/rencet-news" },
            ]}
          />

          <FooterColumn
            title="مواقع التواصل"
            links={[
              { label: "أحداث", to: "/events" },
              { label: "قالوا عنا", to: "/spoken" },
              { label: "المدونة", to: "/blog" },
              { label: "الخصوصية", to: "/privacy" },
            ]}
          />

          <FooterColumn
            title="حملات وإغاثة"
            links={[
              { label: "مواسم الخير", to: "#" },
              { label: "إغاثة عاجلة", to: "#" },
              { label: "حالات إنسانية", to: "#" },
              { label: "كوارث طبيعية", to: "#" },
            ]}
          />

          <FooterColumn
            title="البرامج"
            links={[
              { label: "التعليم", to: "#" },
              { label: "الصحة", to: "#" },
              { label: "كفالة اليتيم", to: "#" },
              { label: "تنمية المجتمع", to: "#" },
            ]}
          />

          <FooterColumn
            title="المزيد"
            links={[
              { label: "التطوع", to: "#" },
              { label: "التقارير المالية", to: "#" },
              { label: "الوظائف", to: "#" },
              { label: "مواقعنا", to: "#" },
            ]}
          />
        </div>

        {/* Bottom Section: Copyright & Social */}
        <div className="border-t border-neutral-200 py-8 flex flex-col md:flex-row justify-between items-center gap-6">
          <div className="text-neutral-500 text-sm">
            جميع الحقوق محفوظة لصالح مؤسسة الخير @{currentYear}
          </div>

          <div className="flex gap-8 text-neutral-900 text-sm font-medium">
            <Link to="#" className="hover:text-[#163A8F] transition-colors">
              حقوق الملكية الفردية
            </Link>
            <Link to="#" className="hover:text-[#163A8F] transition-colors">
              سياسة الإستخدام
            </Link>
          </div>

          <div className="flex items-center gap-4">
            <SocialIcon Icon={Facebook} />
            <SocialIcon Icon={Twitter} />
            <SocialIcon Icon={Linkedin} />
            <SocialIcon Icon={Instagram} />
            <SocialIcon Icon={MessageCircle} />
          </div>
        </div>
      </div>
    </footer>
  );
}

// Sub-components for cleaner code
function FooterColumn({ title, links }) {
  return (
    <div className="flex flex-col gap-6">
      <h4 className="text-[#163A8F] text-lg font-bold">{title}</h4>
      <ul className="flex flex-col gap-4">
        {links.map((link, idx) => (
          <li key={idx}>
            <Link
              to={link.to}
              className="text-neutral-600 hover:text-[#163A8F] hover:translate-x-[-4px] transition-all inline-block text-sm"
            >
              {link.label}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}

function SocialIcon({ Icon }) {
  return (
    <Link
      to="#"
      className="text-neutral-400 hover:text-[#163A8F] hover:scale-110 transition-all"
    >
      <Icon size={20} />
    </Link>
  );
}

export default Footer;
